export default __webpack_public_path__ + "static/IP_Vision_Pro_08-18200fe9dd46b497534f9304a2f2dd22.webp";